export default __webpack_public_path__ + "static/media/ai_badge.e588c99f.svg";